import { ReactionOptions } from "fluidstate";
import {
	getCallbackName,
	getDisposePropertyName,
	getPreactEffectClass,
} from "./reactive-layer-hacky-utils";

const PreactEffect = getPreactEffectClass();

const callbackPropertyName = getCallbackName();

/**
 * Extension of `@preact/signals-core` Effect in order to add
 * the ability to schedule effects. A variety of hacky deductions
 * are made in order to extend the preact's Effect class
 */
export class Effect extends PreactEffect {
	private options?: ReactionOptions;

	constructor(fn: () => void, options?: ReactionOptions) {
		super(fn);
		this.options = options;
		this[callbackPropertyName]();
	}

	[callbackPropertyName](): void {
		if (this.options?.scheduler) {
			this.options.scheduler(
				PreactEffect.prototype[callbackPropertyName].bind(this)
			);
		} else {
			PreactEffect.prototype[callbackPropertyName].call(this);
		}
	}

	stop() {
		return this[getDisposePropertyName()]();
	}
}
